import { defineComponent, h } from 'vue'

export default defineComponent({
    props: {
        json: {
            type: Object,
            required: true,
        },
    },
    setup(props) {
        return () =>
            h('script', {
                type: 'application/ld+json',
                innerHTML: JSON.stringify(props.json),
            })
    },
})
